import { validationApi } from '@/libs/axios/validator';

export const validatePhone = async (phone: string) => {
  const unformattedPhone = phone.replace(/\D/g, '');
  const { data } = await validationApi.get<PhoneValidation>(
    `phone?phoneNumber=${unformattedPhone}`
  );
  return data;
};

type PhoneValidation = {
  isPhoneValid: boolean;
};
